<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n({ useScope: 'global' });
const tagValue = ref('');

const tags = defineModel({
    default: () => [],
});

watch(
    () => tags.value,
    (newVal) => {
        if (!newVal) {
            tags.value = [];
        }
    },
    { immediate: true }
);

const addTag = () => {
    const trimmedTag = tagValue.value.trim();
    if (trimmedTag && !tags.value?.includes(trimmedTag)) {
        tags.value.push(trimmedTag);
    }
    tagValue.value = '';
};

const removeTag = (index) => {
    tags.value.splice(index, 1);
};

const handleBackspace = () => {
    if (!tagValue.value && tags.value.length) {
        tags.value.pop();
    }
};
</script>
<template>
    <div class="tags-input">
        <div class="tags-list">
            <span v-for="(tag, index) in tags || []" :key="index" class="tag">
                {{ tag }}
                <button @click="removeTag(index)" class="remove-btn">×</button>
            </span>
        </div>
        <input v-model="tagValue" @keydown.enter.prevent="addTag" @keydown.space.prevent="addTag" @keydown.backspace="handleBackspace" :placeholder="t('create_session.add_tag')" class="input" />
    </div>
</template>

<style scoped>
.tags-input {
    @apply flex flex-wrap gap-2 border p-2 rounded-xl border-solid border-[#ccc];
}
.tags-list {
    @apply flex flex-wrap gap-2;
}
.tag {
    @apply bg-gray-200 text-gray-900 rounded flex items-center gap-2 text-xs p-1;
}
.remove-btn {
    @apply text-gray-500 cursor-pointer border-[none];
    background: none;
}
.input {
    @apply flex-1 border-[none];
    outline: none;
}
</style>
